import { useAclStore } from '@/store/modules/acl';
function checkAcl(value) {
    const { getAdmin, getPermission } = useAclStore();
    if (getAdmin)
        return true;
    if (!value)
        return true;
    const required = Array.isArray(value) ? value : [value];
    return required.some((p) => getPermission.includes(p));
}
export default {
    install(app) {
        /**
         * @description 自定义指令 v-acl（只判断权限点）
         */
        app.directive('acl', {
            mounted(el, binding) {
                if (!checkAcl(binding.value)) {
                    el.parentNode?.removeChild(el);
                }
            },
        });
    },
};
// 导出手动检查权限的方法
export function checkPermission(permission) {
    return checkAcl(permission);
}
